<div class="container-fluid">
  <page-header-search
    [isSearchInput]="false"
    [pageTitleValue]="pageTitle"
  ></page-header-search>

  <accordion [isAnimated]="true" [closeOthers]="true">
    <accordion-group *ngFor="let item of FAQsArray">
      <h5 class="mb-0 accordion-header d-flex justify-content-between align-items-center" accordion-heading>
        {{ item.question }}
        <button
          placement="top"
          tooltip="Delete"
          (click)="onDeleteFAQ($event, item)"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-trash"> </i>
          </span>
        </button>
      </h5>
      {{ item.answer }}
    </accordion-group>
  </accordion>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
